import { AfterViewInit, Component, OnInit } from '@angular/core';
import { HeaderService } from '../../service/header/header.service';
import { LoggingService } from 'src/app/service/logging-service/logging.service';
import {
  ActivatedRoute,
  NavigationCancel,
  NavigationEnd,
  Router,
} from '@angular/router';
import { Market } from '@app/model/payment-request/payment-request.dto';
import { UserService } from '@app/service/user-service/user.service';
import { CheckoutStatus, ZaverProduct } from '@app/service/state/state.service';
import { PaymentRequestService } from '@app/service/paymentrequest/payment-request.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  public partnerLogoUri: string;

  clickCounter = 0;
  displayMerchantLogo: boolean = true;
  hideCancelButton: boolean = false;
  market: Market;
  cancelUrl: string;
  navigationInProgress: boolean = false;
  loading: boolean = true;
  checkoutStatus: CheckoutStatus;
  modalActive: boolean = false;
  modalTitle: string;
  modalText: string;
  secondaryButtonText: string;
  primaryButtonText: string;

  constructor(
    private headerService: HeaderService,
    private loggingService: LoggingService,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private paymentRequestService: PaymentRequestService
  ) {}

  ngOnInit(): void {
    this.headerService.registerHeaderInstance(this);
  }

  ngAfterViewInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        this.hideCancelButton = Boolean(
          this.route.children[0]?.snapshot.data.hideCancelButton
        );
      }
      this.market = this.headerService.market;
      this.getModalTextTranslations();
      this.cancelUrl = this.headerService.cancelUrl;
      this.checkoutStatus = this.headerService.checkoutStatus;
    });

    this.loading = false;
  }

  public setPartnerLogoUri(logoUri: string) {
    this.partnerLogoUri = logoUri;
    this.displayMerchantLogo = Boolean(this.partnerLogoUri);
  }

  async routeToCancelUrl(): Promise<void> {
    this.navigationInProgress = true;
    try {
      let resp;
      if (
        this.headerService.zaverProduct === ZaverProduct.TOKENIZED_ONBOARDING
      ) {
        resp = await this.userService.cancelPayerToken();
      } else if (this.market === Market.SE) {
        resp = await this.paymentRequestService.cancelPaymentRequest();
      } else {
        resp = await this.userService.cancelPayment();
      }

      if (resp.success) {
        window.location.href = this.cancelUrl;
      } else {
        this.navigationInProgress = false;
      }
    } catch (error) {
      this.loggingService.warn(
        'Header failed to route to cancel url due to: ' + JSON.stringify(error)
      );
    }
  }

  setModalActive(value: boolean): void {
    this.modalActive = value;
  }

  report(): void {
    if (this.clickCounter < 8) {
      this.clickCounter++;
      return;
    }
    this.loggingService.manualReport();
    this.clickCounter = 0;
  }

  public hideMerchantLogo() {
    this.displayMerchantLogo = false;
  }

  getModalTextTranslations(): void {
    switch (this.headerService.market) {
      case Market.SE:
        this.modalTitle = 'Vill du verkligen avbryta?';
        this.modalText =
          'Om du avbryter kommer du att omdirigeras tillbaka till återförsäljaren.';
        this.secondaryButtonText = 'Nej, fortsätt';
        this.primaryButtonText = 'Ja, avbryt';
        break;
      case Market.NO:
        this.modalTitle = 'Vil du virkelig avbryte?';
        this.modalText =
          'Hvis du avbryter, blir du omdirigert tilbake til forhandleren.';
        this.secondaryButtonText = 'Nei, fortsett';
        this.primaryButtonText = 'Ja, avbryt';
        break;
      case Market.AT:
      case Market.DE:
        this.modalTitle = 'Möchten Sie wirklich abbrechen?';
        this.modalText =
          'Wenn Sie jetzt abbrechen, werden Sie zum Händler zurückgeleitet.';
        this.secondaryButtonText = 'Nein, fortsetzen';
        this.primaryButtonText = 'Ja, abbrechen';
        break;
      default:
        this.modalTitle = 'Do you really want to cancel?';
        this.modalText =
          'If you cancel, you will be redirected back to the merchant.';
        this.secondaryButtonText = 'No, continue';
        this.primaryButtonText = 'yes, cancel';
    }
  }
}
